import React from 'react';
import { default as Formulario } from '../../components/faleConosco';

import Header from "../../components/shared/header";

const FaleConosco = (props) => {
  return (
    <>
       <Header/>
      <Formulario />
    </>
  )
}

export default FaleConosco;
